import { render } from "./BrickComponent.vue?vue&type=template&id=20802630"
import script from "./BrickComponent.vue?vue&type=script&lang=js"
export * from "./BrickComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__